import React, { Component } from "react";
import Radium, { StyleRoot } from "radium";
import { Switch, Route, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { loadReCaptcha } from "react-recaptcha-v3";
import Alert from "sweetalert-react";
import ReactGA from "react-ga";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import "react-notifications/lib/notifications.css";
import "sweetalert/dist/sweetalert.css";

import Utils from "../../lib/utils";
import DiscordModal from "../Shared/DiscordModal";
import { DefaultLayout, LogInLayout } from "../Layouts";
import { getUserByToken as getUserByTokenAction } from "../../redux/middleware/user";
import { Loader } from "../Shared";

import "../../styles/RalewayFontcss.css";
import "../../styles/animate.css";
import "../../styles/bootstrap-combined.min.css";
import "../../styles/custom.css";
import "../../styles/font-awesome.css";


export class App extends Component {
  componentWillMount() {
    const { getUserByToken } = this.props;
    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
    ReactGA.pageview(window.location.pathname + window.location.search);
    const userToken = Utils.getUserToken();
    getUserByToken(userToken);
    this.setState({ show: false, showDiscord: false });
  }

  componentDidMount() {
    //loadReCaptcha(process.env.REACT_APP_GOOGLE_RECAPTCHA);
  }

  createNotification = (type, message, title = null) => {
    switch (type) {
      case "success":
        NotificationManager.success(message, title);
        break;
      case "warning":
        NotificationManager.warning(message, title, 3000);
        break;
      case "error":
        NotificationManager.error(message, title, 5000);
        break;
      default:
        NotificationManager.info(message);
        break;
    }
  };

  logout = (history) => {
    const { user } = this.state;
    this.setState({ showLogOutAlert: true });
    setTimeout(() => {
      this.setState({ showLogOutAlert: false });
      localStorage.clear();
      if (user && user.role === "employer") {
        //history.push('/login')
        window.location.href = "/login";
      } else {
        //history.push('/')
        window.location.href = "/";
      }
    }, 3000);
  };

  showDiscordModal = () => {
    this.setState({ showDiscord: true });
  };

  hideDiscordModal = () => {
    this.setState({ showDiscord: false });
  };

  render() {
    const styles = {
      container: {
        backgroundColor: "#093949",
        minHeight: "100%",
        minWidth: 375,
        position: "relative",
        zIndex: 10,
      },
    };

    const stripeKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
    const stripePromise = loadStripe(stripeKey);
    const { showLogOutAlert, showDiscord } = this.state;
    const { user } = this.props;

    return (
      <Elements stripe={stripePromise}>
        <StyleRoot>
          <div className="app" style={styles.container}>
            <Switch>
              <Route
                path="/login"
                render={(props) => <LogInLayout user={user} {...props} />}
              />
              <Route
                path="*"
                render={(props) => (
                  <DefaultLayout
                    user={user}
                    logout={this.logout}
                    notify={this.createNotification}
                    showDiscordModal={this.showDiscordModal}
                    {...props}
                  />
                )}
              />
            </Switch>
            <Alert
              show={showLogOutAlert}
              title="Logout"
              text="You are logged out!"
              onConfirm={() => this.setState({ show: false })}
              type="success"
            />
            <NotificationContainer />
            <DiscordModal
              show={showDiscord}
              hide={() => this.hideDiscordModal()}
            />
          </div>
        </StyleRoot>
      </Elements>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.userByToken.user,
  error: state.userByToken.error,
  pending: state.userByToken.pending,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUserByToken: getUserByTokenAction,
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Radium(App))
);
